// ─── Collage Edit Context ─────────────────────────────────────
// Bridges the editor sidebar and the phone preview canvas.
// When editing, CollageCanvas reads this context to render
// interactive drag handles on top of elements.

import { createContext } from 'react';

export const CollageEditContext = createContext(null);

// Expected shape when provided:
// {
//   onElementMove: (sectionId, elementId, { x, y }) => void,
//   onElementResize: (sectionId, elementId, newWidth) => void,
//   onElementRotate: (sectionId, elementId, newRotation) => void,
//   selectedElement: { sectionId, elementId } | null,
//   onSelectElement: (sectionId, elementId) => void,
//   editingElement: { sectionId, elementId } | null,
//   onEditElement: (sectionId, elementId) => void,
//   onEditText: (sectionId, elementId, field, value) => void,
//   layoutMode: 'mobile' | 'desktop',
// }
